import { isEqual, sortBy } from "lodash";

export const getChangedItemsInArray = (originalArray, updatedArray, key = 'id') => {
    
    const added = updatedArray?.filter(
      updatedItem => !originalArray?.some(original => original[key] === updatedItem[key])
    );

    const removed = originalArray?.filter(
      original => !updatedArray?.some(updated => updated[key] === original[key])
    );

    const modified = updatedArray?.filter(updatedItem => {
      const originalItem = originalArray?.find(original => original[key] === updatedItem[key]);
      return originalItem && !isEqual(originalItem, updatedItem);
    });

    return { added, removed, modified };
  };

  export const getUpdatedObject = (original, updated) => {
    if (typeof original !== typeof updated) return updated;

    if (typeof original !== 'object' || original === null || updated === null) {
      return original === updated ? undefined : updated;
    }

    if (Array.isArray(original) && Array.isArray(updated)) {
      if (original.length !== updated.length || !original.every((v, i) => JSON.stringify(v) === JSON.stringify(updated[i]))) {
        return updated;
      }
      return undefined;
    }

    const diff = {};
    for (const key in updated) {
      const updatedValue = getUpdatedObject(original[key], updated[key]);
      if (updatedValue !== undefined) {
        diff[key] = updatedValue;
      }
    }

    return Object.keys(diff).length ? diff : undefined;
  };

  export const compareDataForUpdateOnServer = (_original, _modified) => {
    const sortedOriginal = sortBy(_original, 'id');
    const sortedModified = sortBy(_modified, 'id');
    const isSame = isEqual(sortedOriginal, sortedModified);
    console.log("isSame : ", isSame);
    return isSame;
  }
